import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as TasksActions from './task.action';
import { GeneralSignalRResponse } from 'src/app/services/signal-r/general-signal-r-response';
import { SignalRService } from 'src/app/services/signal-r/signal-r.service';
import { SignalRAction } from 'src/app/services/signal-r/signalr-enums';
import { Channels } from 'src/app/store/channels';

@Injectable({
  providedIn: 'root'
})
export class TasksStoreAndListenersService {
  constructor(private store: Store, private signalRService: SignalRService) { }

  initListeners() {
    this.signalRService.hubConnection?.on(Channels.TASKS, (data: GeneralSignalRResponse) => {
      this.signalRService.setSender(data.userID);
      switch (data.action) {
        case SignalRAction.Add:
          this.store.dispatch(new TasksActions.TasksCreate(data.obj));
          break;

        case SignalRAction.Update:
          this.store.dispatch(new TasksActions.TasksUpdate(data.id, data.obj));
          break;

        case SignalRAction.Delete:
          this.store.dispatch(new TasksActions.TasksDelete(data.id));
          break;

        case SignalRAction.Get:
          this.store.dispatch(new TasksActions.TasksRefresh(data.id));
          break;
      }
    });
  }
}
